import { Box, Paper, Typography } from "@mui/material";
import LinearProgressWithLabel from "components/LinearProgressWithLabel";
import React from "react";
import ReactPlayer from "react-player/lazy";

const ProductVideoUploadStatus = ({
  file,
  progress = 0,
  status = "pending",
}) => {
  return (
    <Paper
      sx={{
        display: "flex",
        height: 150,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 2,
      }}
      elevation={1}
    >
      <Box
        display="flex"
        sx={{
          flexGrow: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ReactPlayer width={200} height={150} url={file.preview} />
        <LinearProgressWithLabel value={progress} status={status} />
        <Typography margin={1}>{status}</Typography>
      </Box>
    </Paper>
  );
};

export default ProductVideoUploadStatus;
